import "../styles/Navbar.css"
import "../styles/Various.css"

import {
  faFacebook,
  faLinkedin,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Helmet } from "react-helmet-async"
import React from "react"

const Footer = () => {
  return (
    <footer className="footer mt-auto">
      <Helmet>
        <meta
          name="description"
          content="Iris Ambiente Sas - Strategie per l'Ambiente"
        />
      </Helmet>
      <div className="container text-center my-3">
        <div className="footer-text mb-2 d-flex flex-column flex-sm-row align-items-center justify-content-center">
          <div className="mb-1 mb-sm-0">
            <a
              href="mailto:iris@irisambiente.it"
              target="_blank"
              rel="noopener"
            >
              iris@irisambiente.it
            </a>
          </div>
          <span className="d-none d-sm-inline mx-2">|</span>
          <a href="tel:+393357123458" target="_blank" rel="noopener">
            +39 3357123458
          </a>
        </div>
        <div className="footer-text mb-2">
          <FontAwesomeIcon icon={faWhatsapp} className="footer-text mx-1" />
          <a
            href="https://wa.me/393703524036"
            target="_blank"
            rel="noopener noreferrer"
          >
            +39 3703524036
          </a>
        </div>
        <a
          href="https://www.facebook.com/pages/category/Local-Business/IRIS-Ambiente-380072679828/"
          target="_blank"
          rel="noopener"
        >
          <FontAwesomeIcon
            icon={faFacebook}
            className="footer-text social mx-2"
          />
        </a>
        <a
          href="https://www.linkedin.com/company/iris-ambiente-sas/about/"
          target="_blank"
          rel="noopener"
        >
          <FontAwesomeIcon icon={faLinkedin} className="footer-text social" />
        </a>
        <p className="copyright">
          © {new Date().getFullYear()} IRIS Ambiente - Foto Maurizio Bacci
        </p>
      </div>
    </footer>
  )
}

export default Footer
